/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown>, max: NonNullable<unknown> }} Datasets_Import_Csv_Too_LargeInputs */



/**
* | output |
* | --- |
* | "This file is {size} — the maximum import size is {max}." |
*
* @param {Datasets_Import_Csv_Too_LargeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_import_csv_too_large = /** @type {((inputs: Datasets_Import_Csv_Too_LargeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Import_Csv_Too_LargeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Diese Datei ist ${i?.size} groß — die maximale Importgröße beträgt ${i?.max}.`)
	return /** @type {LocalizedString} */ (`This file is ${i?.size} — the maximum import size is ${i?.max}.`)
});